import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=425f9fde&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"
import style0 from "./OtpModal.vue?vue&type=style&index=0&id=425f9fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f9fde",
  null
  
)

export default component.exports